<div [ngClass]="{'always-enabled': enabled}">
  <app-form-group label="Transfer to">
    @if (!context.visit.nextDeclarant && !nextOwner) {
      <app-search [disabled]="!enabled" [(ngModel)]="nextOwner"
                  [searchFunction]="searchShipOperator" placeholder="Find organisation" dataKey="fullName">
      </app-search>
    }

    @if (nextOwner && !context.visit.nextDeclarant) {
      <div>
        <button class="btn btn-secondary me-1" (click)="authorise()">Authorise {{ nextOwner?.fullName }}</button>
        <button class="btn btn-secondary me-1" (click)="undoAuthorise()"><span class="fa fa-fw fa-undo-alt"></span>
        </button>
      </div>
    }

    @if (context.visit.nextDeclarant && !context.isOrganisationNextDeclarant()) {
      @if (context.visit.nextDeclarant) {
        <button (click)="transferVisit()" class="btn btn-secondary me-1">
          <span class="fa fa-fw fa-people-arrows me-1"></span>Transfer to {{ this.context.visit.nextOwner.fullName }}
        </button>
      }
      @if (context.visit.nextDeclarant) {
        <button (click)="unAuthorise()" class="btn btn-secondary me-1"><span
          class="fa fa-fw fa-undo-alt"></span></button>
      }
    }
  </app-form-group>
</div>
